module.exports = __webpack_public_path__ + "static/media/7.3de496b0.jpeg";